//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'


export default {
    data() {
            return {
                column: null
            }
        },
        mounted() {
            axios.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/?json=true')
                .then((response) => {
                    this.column = response.data.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        filters: {
            shortTitle(input) {
                if (input.length > 15) {
                    return input.slice(0, 15) + '...';
                } else {
                    return input
                }
            }
        }
}



// WEBPACK FOOTER //
// ./src/components/xcolumn.vue